module.exports = __webpack_public_path__ + "media/typing-advanced-start.a8d5490b.mp3";